import { createAction } from '@reduxjs/toolkit';

export const storeLogout = createAction('store/logout');
